export default __webpack_public_path__ + "static/media/crop_pattern_summer.79f1b385.jpg";